// extracted by mini-css-extract-plugin
export var buttons = "CommentForm-module--buttons--GIhg3";
export var commentForm = "CommentForm-module--comment-form--3F3OI";
export var title = "CommentForm-module--title--3ZNz-";
export var bottom = "CommentForm-module--bottom--2iSTf";
export var name = "CommentForm-module--name--cpik-";
export var send = "CommentForm-module--send--13-XK";